import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const BAJAS="bajas"
const BAJAS_ID=(id)=>`${BAJAS}/${id}`
const BAJAS_CONTABILIDAD=(id)=>`${BAJAS_ID(id)}/contabilidad`
const ACCOUNTING=(id)=>`${BAJAS_ID(id)}/accounting`
const EARNINGS=(id)=>`${BAJAS_ID(id)}/earnings`


export const bajaContabilidadPut = (bajaId,data) => {
    const controller= loadAbort()
    const call= axios.put(BAJAS_CONTABILIDAD(bajaId),data,{signal:controller.signal})
    return {call,controller}
}
export const bajaIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(BAJAS_ID(id),{signal:controller.signal, params})
    return {call,controller}

}
export const bajaPut = (id,data) => {
    const controller= loadAbort()
    const call= axios.put(BAJAS_ID(id),data,{signal:controller.signal})
    return {call,controller}

}
export const bajaPost = (data) => {
    const controller= loadAbort()
    const call= axios.post(BAJAS,data,{signal:controller.signal})
    return {call,controller}
}
export const bajaDelete = (id) => {
    const controller= loadAbort()
    const call= axios.delete(`${BAJAS}/${id}`,{signal:controller.signal})
    return {call,controller}
}
export const accountingGet = ({id}) => {
    const controller= loadAbort()
    const call= axios.get(ACCOUNTING(id),{signal:controller.signal})
    return {call,controller}
}
export const earningsGet = ({id}) => {
    const controller= loadAbort()
    const call= axios.get(EARNINGS(id),{signal:controller.signal})
    return {call,controller}
}
export const earningsPost = (id, data) => {
    const controller= loadAbort()
    const call= axios.post(EARNINGS(id), data, {signal:controller.signal})
    return {call,controller}
}
export const earningsIdPut = (bajaId, earningId, data) => {
    const controller= loadAbort()
    const call= axios.put(`${EARNINGS(bajaId)}/${earningId}`, data, {signal:controller.signal})
    return {call,controller}
}
export const earningsIdDelete = (bajaId, earningId) => {
    const controller= loadAbort()
    const call= axios.delete(`${EARNINGS(bajaId)}/${earningId}`, {signal:controller.signal})
    return {call,controller}
}
